var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-popover',{attrs:{"placement":"right","trigger":"hover"}},[_c('img',{staticClass:"w-full h-full inline-block",attrs:{"slot":"reference","src":_vm.joinHead(_vm.src),"alt":""},slot:"reference"}),_c('div',[_c('img',{staticClass:"w-80 h-80",attrs:{"src":_vm.joinHead(_vm.src),"alt":""}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }